const lineItem = { OOS_QTY: '--' };

export { lineItem };
